import React from 'react';

export function InputCounter(props) {
  
  return ( 
      <div className='form__input_counter'>
    <button type='button' onClick={props.handleDecrease} className='gg-decrease'/>
    <input
      type="number"
      disabled={props.disabled}
      value={props.values}
      min={props.min}
      readOnly
      onChange={props.handleChange}
      className='form__input_capacity font20Norm'
      name={props.name}
      id={props.id}
      step={props.step}
    />
    <button type='button' onClick={props.handleIncrease} className='gg-increase'/>
    </div>
  )        
}
  
  